import { useDeviceType } from '@cian/ui-kit';
import { Socials } from 'shared/components/Socials';
import type { TSocialItem } from 'shared/types/socials';
import { mapSocialItems } from 'shared/utils/socials';

interface ISocialsContainerProps {
  items: TSocialItem[];
}

export const SocialsContainer: React.FC<ISocialsContainerProps> = ({ items }) => {
  const renderedItems = mapSocialItems(items);

  const device = useDeviceType();

  if (!renderedItems.length) {
    return null;
  }

  return <Socials device={device} items={renderedItems} />;
};
